// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"328":"85697f05","424":"e557ee7a","703":"f3cc6629","723":"332aaa50","729":"51ee9829","745":"ad99b0f5","850":"7cb6cd7b"}[chunkId] + ".chunk.css";
};